/* SnugglyMates - Mix & Match Quantity-Break widget
 * Display + guided cross-product add. Pairs with sm-quantity-break-bundle.liquid.
 * The real discount is your Shopify automatic quantity discount; this only
 * shows progress and shuttles the customer between products.
 */
(function () {
  'use strict';

  // ------------------------------ CONFIG ------------------------------
  // Keep these tiers in sync with your Shopify automatic discount.
  var TIERS = [
    { qty: 2, pct: 15 },
    { qty: 3, pct: 20 },
    { qty: 4, pct: 25 }
  ];

  // Which cart lines count toward the bundle? Must MATCH the product scope of
  // your Shopify discount. Default = every item counts.
  // To limit to blankets only, e.g.:  return line.product_type === 'Blanket';
  function qualifies(line) {
    return true;
  }

  var PARAM = 'return_to';         // URL param carrying the page to return to
  var STORE_KEY = 'qbb_return';    // sessionStorage key for the return URL
  var POLL_MS = 1500;              // how often to check the cart
  var POLL_TIMEOUT_MS = 10 * 60 * 1000; // stop watching after 10 min
  // --------------------------------------------------------------------

  function getRoot() { return document.querySelector('[data-qbb]'); }

  function getParam(name) {
    try { return new URLSearchParams(window.location.search).get(name); }
    catch (e) { return null; }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function qualifyingQty(cart) {
    return cart.items.reduce(function (sum, line) {
      return qualifies(line) ? sum + line.quantity : sum;
    }, 0);
  }

  function nextTier(qty) {
    for (var i = 0; i < TIERS.length; i++) {
      if (qty < TIERS[i].qty) return TIERS[i];
    }
    return null;
  }

  // ---------------- PDP widget: show tiers + progress ----------------
  // Progressive unlock: a tier's "Add item" button is enabled only when the
  // customer is exactly one item away from it (i.e. has reached the tier above).
  function renderWidget(root, qty) {
    root.querySelectorAll('.qbb__tier').forEach(function (li) {
      var tierQty = parseInt(li.getAttribute('data-tier-qty'), 10);
      var state = li.querySelector('.qbb__state');
      var addBtn = li.querySelector('.qbb__add-item');

      var unlocked = qty >= tierQty;              // already reached
      var isNext = !unlocked && qty >= tierQty - 1; // the next step to take

      li.classList.toggle('is-unlocked', unlocked);
      li.classList.toggle('is-active', isNext);
      if (state) state.textContent = unlocked ? '✓ Unlocked' : '';

      if (addBtn) {
        addBtn.classList.toggle('is-disabled', !isNext);
        addBtn.setAttribute('aria-disabled', String(!isNext));
        if (isNext) { addBtn.removeAttribute('tabindex'); }
        else { addBtn.setAttribute('tabindex', '-1'); }
      }
    });

    var hint = root.querySelector('[data-qbb-hint]');
    if (hint) {
      var nt = nextTier(qty);
      if (qty <= 0) {
        hint.textContent =
          'Add a blanket to get started, then buy 2 to unlock 15% off.';
      } else if (nt) {
        hint.textContent =
          'In your cart: ' + qty + '. Add ' + (nt.qty - qty) +
          ' more to unlock ' + nt.pct + '% off.';
      } else {
        hint.textContent =
          'In your cart: ' + qty + '. You have unlocked the biggest discount 🎉';
      }
    }
  }

  // Re-read the cart and repaint. Safe to call often (debounced below).
  function refresh() {
    var root = getRoot();
    if (!root) return;
    fetchCart()
      .then(function (cart) { renderWidget(root, qualifyingQty(cart)); })
      .catch(function () {});
  }

  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 250);
  }

  // Send the customer to the collection to add another design, remembering
  // the page they came from so we can bring them back.
  function goAddAnother(root) {
    var ret = root.getAttribute('data-return-url') || window.location.pathname;
    try { sessionStorage.setItem(STORE_KEY, ret); } catch (err) {}
    var col = root.getAttribute('data-collection-url') || '/collections/all';
    window.location.href = col + '?' + PARAM + '=' + encodeURIComponent(ret);
  }

  function initWidget() {
    var root = getRoot();
    if (!root) return;

    // Per-tier "Add item" buttons share the same guided-add action, but only
    // fire when enabled (the current next step).
    root.querySelectorAll('[data-qbb-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.classList.contains('is-disabled')) return;
        goAddAnother(root);
      });
    });

    refresh();
  }

  // ---- Keep the widget in sync when the cart changes anywhere on the page ----
  function watchCart() {
    var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js|\.json)?/i;

    // 1) Wrap fetch (cart drawers, quantity steppers, remove links use this).
    if (window.fetch && !window.__qbbFetchPatched) {
      var origFetch = window.fetch;
      window.fetch = function () {
        var input = arguments[0];
        var url = (input && input.url) ? input.url : String(input || '');
        var p = origFetch.apply(this, arguments);
        if (CART_MUTATION.test(url)) {
          p.then(function () { scheduleRefresh(); }).catch(function () {});
        }
        return p;
      };
      window.__qbbFetchPatched = true;
    }

    // 2) Wrap XMLHttpRequest (older themes / some apps).
    if (window.XMLHttpRequest && !window.__qbbXhrPatched) {
      var open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__qbbUrl = url;
        return open.apply(this, arguments);
      };
      var send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.send = function () {
        if (CART_MUTATION.test(this.__qbbUrl || '')) {
          this.addEventListener('loadend', scheduleRefresh);
        }
        return send.apply(this, arguments);
      };
      window.__qbbXhrPatched = true;
    }

    // 3) Common custom events some themes/apps fire.
    ['cart:updated', 'cart:refresh', 'cart:change', 'ajaxCart:afterCartLoad']
      .forEach(function (ev) { document.addEventListener(ev, scheduleRefresh); });

    // 4) Coming back to the tab / bfcache restore -> re-check.
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleRefresh();
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        var pending = false;
        try { pending = sessionStorage.getItem('qbb_open_cart') === '1'; } catch (err) {}
        // Returned from a guided bundle add and the browser restored this page
        // from bfcache: the cart drawer still shows pre-add contents. Force one
        // fresh load so it repaints; keep the flag so boot() then opens the drawer.
        if (pending) { window.location.reload(); return; }
        scheduleRefresh();
      }
    });
  }

  // -------- Guided flow: return to origin after an item is added --------
  function initReturnFlow() {
    var fromUrl = getParam(PARAM);
    if (fromUrl) {
      try { sessionStorage.setItem(STORE_KEY, fromUrl); } catch (e) {}
    }

    var dest = null;
    try { dest = sessionStorage.getItem(STORE_KEY); } catch (e) {}
    if (!dest) return; // not in a bundle-building flow

    // Don't watch while we're already on the destination page.
    if (window.location.pathname === dest.split('?')[0]) {
      try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
      return;
    }

    // Redirect back only once the cart actually grows (works regardless of how
    // Teeinblue completes the personalize-and-add).
    fetchCart().then(function (start) {
      var startCount = start.item_count;
      var stopAt = Date.now() + POLL_TIMEOUT_MS;

      var timer = setInterval(function () {
        if (Date.now() > stopAt) { clearInterval(timer); return; }
        fetchCart().then(function (now) {
          if (now.item_count > startCount) {
            clearInterval(timer);
            var back = null;
            try {
              back = sessionStorage.getItem(STORE_KEY);
              sessionStorage.removeItem(STORE_KEY);
            } catch (e) {}
            if (back) {
              try { sessionStorage.setItem('qbb_open_cart', '1'); } catch (e2) {}
              window.location.href = back;
            }
          }
        }).catch(function () {});
      }, POLL_MS);
    });
  }

  // After a guided bundle add brings the customer back here on a fresh load,
  // open the cart drawer so they land looking at their updated cart.
  function openCartDrawer() {
    var attempts = 0;
    (function tryOpen() {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      if (attempts++ < 20) { setTimeout(tryOpen, 150); }
    })();
  }

  function maybeOpenCartAfterReturn() {
    var pending = false;
    try { pending = sessionStorage.getItem('qbb_open_cart') === '1'; } catch (e) {}
    if (!pending) return;
    try { sessionStorage.removeItem('qbb_open_cart'); } catch (e) {}
    openCartDrawer();
  }

  function boot() {
    watchCart();
    initWidget();
    initReturnFlow();
    maybeOpenCartAfterReturn();
  }

  // Works whether the script is deferred, async, or injected after DOM ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();